document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains('card-product__size-button')) {
      e.preventDefault();
      e.stopPropagation();
      
      const sizeButton = e.target;
      const optionsContainer = sizeButton.closest('.card-product__options-container');
      
      if (!optionsContainer) return;
      
      const allButtons = optionsContainer.querySelectorAll('.card-product__size-button');
      allButtons.forEach(btn => btn.classList.remove('active'));
      
      sizeButton.classList.add('active');
      
      const variantId = sizeButton.getAttribute('data-variant-id');
      const variantInput = optionsContainer.querySelector('.product-variant-id');
      if (variantInput) {
        variantInput.value = variantId;
      }
      
      const isAvailable = sizeButton.getAttribute('data-available') === 'true';
      const submitButton = optionsContainer.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = !isAvailable;
        
        const buttonText = submitButton.querySelector('span:not(.sold-out-message)');
        if (buttonText) {
          buttonText.textContent = isAvailable 
            ? (window.variantStrings?.addToCart || 'Add to cart')
            : (window.variantStrings?.soldOut || 'Sold out');
        }
      }
    }
  });
  
  document.body.addEventListener('click', function(e) {
    if (e.target && (e.target.classList.contains('card-product__add-button') || 
        (e.target.closest('button') && e.target.closest('button').classList.contains('card-product__add-button')))) {
      
      e.preventDefault();
      e.stopPropagation();
      
      const button = e.target.classList.contains('card-product__add-button') ? 
                     e.target : e.target.closest('button');
      const form = button.closest('form');
      
      if (!form) return;
      
      button.disabled = true;
      const spinner = button.querySelector('.loading-spinner');
      if (spinner) spinner.classList.remove('hidden');
      
      const formData = new FormData(form);
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status) {
          console.error(data.description);
          alert(data.description);
          return;
        }
        
        updateCart();
        
        button.disabled = false;
        if (spinner) spinner.classList.add('hidden');
      })
      .catch(error => {
        console.error('Error:', error);
        button.disabled = false;
        if (spinner) spinner.classList.add('hidden');
      });
    }
  });
  
  document.body.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.closest('.card-product__options-container')) {
      e.preventDefault();
      e.stopPropagation();
      
      const submitButton = form.querySelector('button[type="submit"]');
      const spinner = submitButton?.querySelector('.loading-spinner');
      
      if (submitButton) {
        submitButton.disabled = true;
        if (spinner) spinner.classList.remove('hidden');
      }
      
      const formData = new FormData(form);
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status) {
          console.error(data.description);
          alert(data.description);
          return;
        }
        
        updateCart();
        
        if (submitButton) {
          submitButton.disabled = false;
          if (spinner) spinner.classList.add('hidden');
        }
      })
      .catch(error => {
        console.error('Error:', error);
        if (submitButton) {
          submitButton.disabled = false;
          if (spinner) spinner.classList.add('hidden');
        }
      });
    }
  });
  
  function updateCart() {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    } else if (document.querySelector('cart-drawer')) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    } else if (document.querySelector('cart-notification')) {
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification && typeof cartNotification.open === 'function') {
        cartNotification.open();
      }
    }
    
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count-bubble');
        if (cartCountElements.length) {
          cartCountElements.forEach(element => {
            element.textContent = cart.item_count;
            element.classList.remove('hidden');
          });
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }
}); 